import { render, staticRenderFns } from "./rep_number_of_orders_table.vue?vue&type=template&id=4cb3e7b0&scoped=true&"
import script from "./rep_number_of_orders_table.vue?vue&type=script&lang=js&"
export * from "./rep_number_of_orders_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb3e7b0",
  null
  
)

export default component.exports